import React from "react";
import { Check } from "lucide-react";
import { SERVICES } from "../data/mock";
import Reveal from "../components/Reveal";
import { PageHero, SectionHead, NumberedRow, CTABand } from "../components/SharedUI";

const Services = () => {
  const d = SERVICES;
  return (
    <div>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} />

      {/* Two service blocks */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 space-y-24">
          {d.blocks.map((b, i) => (
            <div
              key={b.num}
              className={`grid lg:grid-cols-2 gap-12 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            >
              <Reveal>
                <div>
                  <div className="font-serif text-5xl text-[var(--gold)]/70 mb-5">{b.num}</div>
                  <h2 className="font-serif text-[36px] md:text-[46px] font-semibold text-[#14161c] mb-5">{b.title}</h2>
                  <p className="text-[#55585f] leading-relaxed mb-8 max-w-lg">{b.body}</p>
                  <ul className="space-y-3">
                    {b.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-[#14161c]">
                        <span className="w-6 h-6 rounded-full bg-[var(--gold)]/15 flex items-center justify-center shrink-0">
                          <Check size={14} className="text-[var(--gold)]" />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
              <Reveal delay={120}>
                <div className="img-zoom rounded-sm overflow-hidden shadow-xl">
                  <img src={b.image} alt={b.title} className="w-full h-[420px] object-cover" />
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </section>

      {/* Levels */}
      <section className="grain bg-[#16233f] text-white py-24 md:py-28">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8">
          <Reveal>
            <div className="eyebrow mb-12">{d.levels.eyebrow}</div>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
            {d.levels.items.map((it, i) => (
              <Reveal key={it.num} delay={i * 80}>
                <div className="bg-[#16233f] p-8 h-full hover:bg-[#1b2b4d] transition-colors">
                  <div className="font-serif text-4xl text-[var(--gold)]/70 mb-4">{it.num}</div>
                  <h3 className="font-serif text-xl md:text-2xl font-semibold">{it.title}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-32 self-start">
            <SectionHead eyebrow={d.process.eyebrow} title={d.process.title} />
          </div>
          <div>
            {d.process.steps.map((it, i) => (
              <NumberedRow key={it.num} {...it} delay={i * 80} />
            ))}
            <div className="border-t border-black/10" />
          </div>
        </div>
      </section>

      <CTABand title="Brief us on a role" button={d.cta} />
    </div>
  );
};

export default Services;
